var map = {
	"./Ar_icon.svg": 7,
	"./Calendar.svg": 8,
	"./Certificate.svg": 9,
	"./Ch_icon.svg": 10,
	"./Class.svg": 11,
	"./Contact.svg": 12,
	"./De_icon.svg": 13,
	"./DistanceLearning.svg": 14,
	"./Download.svg": 15,
	"./Ja_icon.svg": 16,
	"./Ko_icon.svg": 17,
	"./LSI-Logo-small.svg": 18,
	"./LSI-Logo.svg": 19,
	"./OnlineTest.svg": 20,
	"./OntToOne.svg": 21,
	"./Pe_icon.svg": 22,
	"./RUB_Logo_BLUE.svg": 23,
	"./Ru_icon.svg": 24,
	"./Search.svg": 25,
	"./Shop.svg": 26,
	"./Travel.svg": 27,
	"./down.svg": 28,
	"./icn-accordion-minus.svg": 29,
	"./icn-accordion-plus.svg": 30,
	"./icn-arrow-left.svg": 31,
	"./icn-arrow-right.svg": 32,
	"./icn-email.svg": 33,
	"./icn-portal.svg": 34,
	"./icn-social-facebook.svg": 35,
	"./icn-social-insta.svg": 36,
	"./icn-social-linkedin.svg": 37,
	"./icn-social-twitter.svg": 38,
	"./icon-arrow-bold-grey.svg": 39,
	"./icon-arrow-bold-orange.svg": 40,
	"./icon-arrow-grey.svg": 41,
	"./icon-arrow-orange.svg": 42,
	"./icon-arrow-right-bold.svg": 43,
	"./icon-arrow-right.svg": 44,
	"./icon-arrow-top.svg": 45,
	"./left.svg": 46,
	"./right.svg": 47,
	"./up.svg": 48,
	"./world.svg": 49
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6;